import React from "react";
import PropTypes from "prop-types";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { XIcon } from "@heroicons/react/outline";

function SMModal(props) {
  return (
    <>
      <Transition appear show={props.show} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto blur-overlay"
          onClose={() => {
            if (!!props.disableOverlayClose) {
              if (!props.disableOverlayClose) {
                props.onClose()
              }
            } else {
                props.onClose()
            }
          }}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full text-gray-800 dark:text-white max-w-lg p-2 my-8 overflow-hidden text-left align-middle transition-all transform bg-white border dark:bg-gray-800 dark:border-gray-600 shadow-xl rounded-2xl">
                <Dialog.Title
                  as="div"
                  className="text-lg flex flex-row justify-between font-medium leading-6 m-4"
                >
                  <h3 className="font-bold">{props.title ?? "Kuesioner"}</h3>
                  <button onClick={() => props.onClose()}>
                    <XIcon className="h-6 w-6" />
                  </button>
                </Dialog.Title>
                <div className="mt-2">{props.children}</div>

                <div className="mt-0">
                  {/* <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-blue-900 bg-blue-100 border border-transparent rounded-md hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500"
                    onClick={() => props.onClose()}
                  >
                    Got it, thanks!
                  </button> */}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

SMModal.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  disableOverlayClose: PropTypes.bool,
};

export default SMModal;
